import { Laptop, Phone, PhoneVibrate, Tablet, Tv } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import ShowItem from "./ShowItem";
import { BugData } from "./types";

const deviceIconFor = (type?: string) => {
  switch ((type || "").toLowerCase()) {
    case "smartphone":
      return Phone;
    case "tablet":
      return Tablet;
    case "pc":
    case "computer":
    case "desktop":
      return Laptop;
    case "smart-tv":
    case "tv":
      return Tv;
    default:
      return PhoneVibrate;
  }
};

interface Props {
  data: BugData;
}

const BugDeviceSection = ({ data }: Props) => {
  const { t } = useTranslation();
  if (!data.tester.device) return null;

  const Icon = deviceIconFor(data.tester.device.type);

  return (
    <ShowItem icon={Icon} label={t("Device")}>
      {data.tester.device.name &&
        data.tester.device.name !== "Unknown Device" &&
        `${data.tester.device.name} - `}
      {data.tester.device.type} - {data.tester.device.operating_system}{" "}
      {data.tester.device.os_version}
    </ShowItem>
  );
};

export default BugDeviceSection;
